import _defineProperty from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.object.to-string.js";
import { getAreaList, updateAreaStatus, setDefault as _setDefault } from '@/services/areaManagement';
export default {
  data: function data() {
    var columns = [{
      title: this.$t('areaManagement.area'),
      dataIndex: 'regionName',
      key: 'regionName',
      width: '50%'
    }, {
      title: this.$t('public.status'),
      dataIndex: 'areaStatus',
      key: 'areaStatus',
      width: '30%',
      scopedSlots: {
        customRender: 'areaStatus'
      }
    }, {
      title: this.$t('public.operation'),
      dataIndex: 'operation',
      key: 'operation',
      width: '20%',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    var innerColumns = [{
      title: this.$t('areaManagement.city'),
      dataIndex: 'addressName',
      key: 'addressName',
      width: '50%'
    }, {
      title: this.$t('public.status'),
      dataIndex: 'areaStatus',
      key: 'areaStatus',
      width: '30%',
      scopedSlots: {
        customRender: 'areaStatus'
      }
    }, _defineProperty(_defineProperty(_defineProperty({
      title: this.$t('public.operation'),
      dataIndex: 'operation',
      key: 'operation'
    }, "key", 'version'), "width", '20%'), "scopedSlots", {
      customRender: 'operation'
    })];
    return {
      columns: columns,
      innerColumns: innerColumns,
      dataList: [],
      isTableLoading: false
    };
  },
  i18n: require('./i18n-areaManagement'),
  mounted: function mounted() {
    var self = this;
    self.getList();
  },
  methods: {
    /* 获取列表数据 */getList: function getList() {
      var self = this;
      self.isTableLoading = true;
      getAreaList().then(function (res) {
        if (res.data.code == 200) {
          self.dataList = res.data.data[0].regionList;
        }
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    /* 启用停用按钮 */updateStatus: function updateStatus(record, type) {
      var _this = this;
      console.log(record);
      var param = {};
      if (type === 'area') {
        param.areaId = record.regionId, param.status = record.areaStatus == 0 ? 1 : 0;
      } else if (type === 'areaDetail') {
        param.areaDetailId = record.id, param.status = record.areaStatus == 0 ? 1 : 0;
      }
      var key = "updateAreaStatusLoading" + type;
      if (record[key]) return;
      record[key] = true;
      updateAreaStatus(param).then(function (response) {
        if (response.data.code == 200) {
          _this.$message.success(_this.$t('public.updateSuccessfully'));
          _this.getList();
        }
      }).finally(function () {
        record[key] = false;
      });
    },
    setDefault: function setDefault(id, record) {
      var _this2 = this;
      if (record.setDefaultLoading) return;
      record.setDefaultLoading = true;
      _setDefault(id).then(function (response) {
        if (response.data.code == 200) {
          _this2.$message.success(_this2.$t('public.updateSuccessfully'));
          _this2.getList();
        }
      }).finally(function () {
        record.setDefaultLoading = false;
      });
    }
  }
};